import React, { useState, useEffect } from 'react';
import DashLayout from '../componets/layout/DashLayout';
import './reviews.css';
import './users.css';
import { supabase } from '../supabaseClient';
import Preloader from '../componets/layout/preloader';

const Reviews = () => {
    const [data, setData] = useState([]);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editItem, setEditItem] = useState(null);
    const [filterEvent, setFilterEvent] = useState('');
    const [search, setSearch] = useState('');

    const initialEditForm = {
        user_name: "", comment_en: "", comment_ar: "",
        rating: 5, status: "Published"
    };
    const [editForm, setEditForm] = useState(initialEditForm);

    useEffect(() => {
        const getData = async () => {
            const { data } = await supabase.from('eventfeedback').select('*');
            setData(data || []);
            setLoading(false);
        };
        const getEvents = async () => {
            const { data } = await supabase.from('events').select('id, title_en');
            setEvents(data || []);
        };
        getData();
        getEvents();
    }, []);

    const openEditModal = (item) => {
        setEditItem(item);
        setEditForm({
            user_name: item.user_name || "",
            comment_en: item.comment_en || "",
            comment_ar: item.comment_ar || "",
            rating: item.rating || 5,
            status: item.status || "Published"
        });
    };

    const updateReview = async (e) => {
        e.preventDefault();
        const updatePayload = {
            user_name: editForm.user_name,
            comment_en: editForm.comment_en,
            comment_ar: editForm.comment_ar,
            rating: editForm.rating,
            status: editForm.status
        };
        const { error } = await supabase.from('eventfeedback').update(updatePayload).eq('id', editItem.id);
        if (!error) {
            setData(prev => prev.map(item => item.id === editItem.id ? { ...item, ...updatePayload } : item));
            setEditItem(null);
        }
    };

    const handleDelete = async (id) => {
        await supabase.from('eventfeedback').delete().eq('id', id);
        setData(prev => prev.filter(item => item.id !== id));
    };

    const getEventTitle = (eventId) => {
        return events.find(e => e.id === eventId)?.title_en || '';
    };

    const filtered = data.filter(item => {
        const matchEvent = filterEvent === '' || String(item.event_id) === filterEvent;
        const matchSearch = search === '' ||
            item.user_name?.toLowerCase().includes(search.toLowerCase()) ||
            item.comment_en?.toLowerCase().includes(search.toLowerCase()) ||
            getEventTitle(item.event_id)?.toLowerCase().includes(search.toLowerCase());
        return matchEvent && matchSearch;
    });

    return (
        <>
                    <Preloader />

            {editItem && (
                <div className="us-overlay">
                    <div className="us-modal">
                        <div className="us-modal-header">
                            <h2 className="us-modal-title">Edit Feedback</h2>
                            <svg className="us-modal-close" onClick={() => setEditItem(null)} viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="us-modal-body">
                            <form className="us-form" onSubmit={updateReview}>
                                <div className="us-form-field">
                                    <label className="us-form-label">Customer Name</label>
                                    <input type="text" className="us-form-input" value={editForm.user_name} onChange={(e) => setEditForm({...editForm, user_name: e.target.value})} />
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Rating</label>
                                        <select className="us-form-select" value={editForm.rating} onChange={(e) => setEditForm({...editForm, rating: Number(e.target.value)})}>
                                            <option value={1}>1 Star</option>
                                            <option value={2}>2 Stars</option>
                                            <option value={3}>3 Stars</option>
                                            <option value={4}>4 Stars</option>
                                            <option value={5}>5 Stars</option>
                                        </select>
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Status</label>
                                        <select className="us-form-select" value={editForm.status} onChange={(e) => setEditForm({...editForm, status: e.target.value})}>
                                            <option value="Published">Published</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Hidden">Hidden</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="us-form-field">
                                    <label className="us-form-label">Review (EN)</label>
                                    <textarea className="us-form-input"  value={editForm.comment_en} onChange={(e) => setEditForm({...editForm, comment_en: e.target.value})}></textarea>
                                </div>
                                <div className="us-form-field">
                                    <label className="us-form-label">Review (AR)</label>
                                    <textarea className="us-form-input"  dir="rtl" value={editForm.comment_ar} onChange={(e) => setEditForm({...editForm, comment_ar: e.target.value})}></textarea>
                                </div>
                                <div className="us-form-footer">
                                    <button type="button" className="us-cancel-btn" onClick={() => setEditItem(null)}>Cancel</button>
                                    <button type="submit" className="us-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Update Review
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <DashLayout title="Feedbacks & Reviews" active="reviews">
                <div className="rv-top">
                    <div className="rv-top-left">
                        <h1 className="rv-title">Feedbacks & Reviews</h1>
                        <p className="rv-sub">View and manage all customer feedback submitted for your events</p>
                    </div>
                </div>

                <div className="rv-filters">
                    <div className="rv-search-wrap">
                        <svg className="rv-search-icon" viewBox="0 0 20 20" fill="none">
                            <circle cx="9" cy="9" r="5.5" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M13 13l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <input type="text" className="rv-search" placeholder="Search feedback..." value={search} onChange={e => setSearch(e.target.value)} />
                    </div>
                    <select className="rv-select" value={filterEvent} onChange={e => setFilterEvent(e.target.value)}>
                        <option value="">All Events</option>
                        {events.map(ev => (
                            <option key={ev.id} value={String(ev.id)}>{ev.title_en}</option>
                        ))}
                    </select>
                </div>

                <div className="rv-list">
                    {loading ? (
                        <p className="loading">Loading...</p>
                    ) : (
                        filtered.map((item) => (
                            <div className="rv-card" key={item.id}>
                                <div className="rv-card-left">
                                    <div className="rv-avatar">
                                        <svg viewBox="0 0 40 40" fill="none">
                                            <circle cx="20" cy="16" r="7" fill="rgba(255,255,255,1)"/>
                                            <path d="M6 36c0-7.732 6.268-14 14-14s14 6.268 14 14" stroke="rgba(255,255,255,1)" strokeWidth="2"/>
                                        </svg>
                                    </div>
                                    <div className="rv-card-info">
                                        <div className="rv-card-name-row">
                                            <p className="rv-card-name">{item.user_name}</p>
                                            <span className="rv-card-role">{getEventTitle(item.event_id)}</span>
                                            <span className={`rv-status-badge rv-status-badge--${item.status?.toLowerCase()}`}>{item.status}</span>
                                        </div>
                                        <div className="rv-stars-row">
                                            {[1,2,3,4,5].map(s => (
                                                <svg key={s} className={s <= (item.rating || 5) ? '' : 'rv-star--empty'} viewBox="0 0 20 20">
                                                    <path d="M10 1l2.39 5.26L18 7.27l-4 3.9.94 5.5L10 14l-4.94 2.67.94-5.5-4-3.9 5.61-.01z"/>
                                                </svg>
                                            ))}
                                        </div>
                                        <p className="rv-card-text">{item.comment_en}</p>
                                    </div>
                                </div>
                                <div className="rv-card-actions">
                                    <button className="rv-view-btn" onClick={() => openEditModal(item)}>
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.5 2.5a2.121 2.121 0 013 3L6 17H3v-3L14.5 2.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                        </svg>
                                    </button>
                                    <button className="rv-delete-btn" onClick={() => handleDelete(item.id)}>
                                        <svg viewBox="0 0 20 20" fill="none">
                                            <path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </DashLayout>
        </>
    );
};

export default Reviews;